// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FileUploadModal.css */

.upload-area {
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    padding: 3rem;
    text-align: center;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
    cursor: pointer;
}

.upload-area:hover {
    border-color: #145886;
    background-color: #e7f1ff;
}

.upload-area.drag-over {
    border-color: #145886;
    background-color: #e7f1ff;
    transform: scale(1.01);
}

.upload-icon {
    font-size: 3rem;
    color: #dee2e6;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
}

.upload-area:hover .upload-icon,
.upload-area.drag-over .upload-icon {
    color: #145886;
}

.progress-section {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
}

.custom-progress {
    height: 8px;
}

.selected-files {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 1rem;
    max-height: 200px;
    overflow-y: auto;
}

.file-item {
    background-color: white;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    transition: all 0.2s ease;
}

.file-item:last-child {
    margin-bottom: 0;
}

.file-item:hover {
    border-color: #145886;
    box-shadow: 0 2px 4px rgba(13, 110, 253, 0.1);
}

.file-name {
    font-weight: 500;
    color: #212529;
    word-break: break-all;
}

/* Custom scrollbar for selected files */
.selected-files::-webkit-scrollbar {
    width: 6px;
}

.selected-files::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.selected-files::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.selected-files::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Modal responsiveness */
@media (max-width: 768px) {
    .upload-area {
        padding: 2rem;
    }
    
    .upload-icon {
        font-size: 2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BRC/FileUploadModal.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA,wCAAwC;AACxC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* FileUploadModal.css */\n\n.upload-area {\n    border: 2px dashed #dee2e6;\n    border-radius: 8px;\n    padding: 3rem;\n    text-align: center;\n    background-color: #f8f9fa;\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.upload-area:hover {\n    border-color: #145886;\n    background-color: #e7f1ff;\n}\n\n.upload-area.drag-over {\n    border-color: #145886;\n    background-color: #e7f1ff;\n    transform: scale(1.01);\n}\n\n.upload-icon {\n    font-size: 3rem;\n    color: #dee2e6;\n    margin-bottom: 1rem;\n    display: flex;\n    justify-content: center;\n}\n\n.upload-area:hover .upload-icon,\n.upload-area.drag-over .upload-icon {\n    color: #145886;\n}\n\n.progress-section {\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    padding: 1.5rem;\n}\n\n.custom-progress {\n    height: 8px;\n}\n\n.selected-files {\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    padding: 1rem;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.file-item {\n    background-color: white;\n    border: 1px solid #e9ecef;\n    border-radius: 6px;\n    padding: 0.75rem;\n    margin-bottom: 0.5rem;\n    transition: all 0.2s ease;\n}\n\n.file-item:last-child {\n    margin-bottom: 0;\n}\n\n.file-item:hover {\n    border-color: #145886;\n    box-shadow: 0 2px 4px rgba(13, 110, 253, 0.1);\n}\n\n.file-name {\n    font-weight: 500;\n    color: #212529;\n    word-break: break-all;\n}\n\n/* Custom scrollbar for selected files */\n.selected-files::-webkit-scrollbar {\n    width: 6px;\n}\n\n.selected-files::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n}\n\n.selected-files::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n}\n\n.selected-files::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}\n\n/* Modal responsiveness */\n@media (max-width: 768px) {\n    .upload-area {\n        padding: 2rem;\n    }\n    \n    .upload-icon {\n        font-size: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
